<mat-toolbar class="mat-elevation-z8">
  Kund <div class="spacer"></div>
</mat-toolbar>

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="mt-3">

  <form [formGroup]="editCustomerForm">
    <mat-form-field appearance="outline">
      <mat-label>Förnamn</mat-label>
      <input matInput formControlName="firstName" placeholder="Förnamn">
      <mat-icon matSuffix>person</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Efternamn</mat-label>
      <input formControlName="lastName" matInput placeholder="Efternamn">
      <mat-icon matSuffix>person</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Telefonnummer</mat-label>
      <input formControlName="cellular" matInput placeholder="Telefonnummer">
      <mat-icon matSuffix>local_phone</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input formControlName="email" type="email" matInput placeholder="Email">
      <mat-icon matSuffix>alternate_email</mat-icon>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="my-3 mx-3" align="end">
  <button mat-raised-button color="primary" [disabled]="isDisabled" (click)="saveChanges()">{{'spara' |
  uppercase}}</button>
  <button mat-button mat-dialog-close>Stäng</button>
</mat-dialog-actions>
